module.exports = __webpack_public_path__ + "static/media/vacation_mode_off_icon.34d9d4a3.svg";